import { render, staticRenderFns } from "./UserDashboardBilling.vue?vue&type=template&id=35294b32&scoped=true&"
import script from "./UserDashboardBilling.vue?vue&type=script&lang=js&"
export * from "./UserDashboardBilling.vue?vue&type=script&lang=js&"
import style0 from "./UserDashboardBilling.vue?vue&type=style&index=0&id=35294b32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35294b32",
  null
  
)

export default component.exports